import { render, staticRenderFns } from "./ProjectContentDisplay.vue?vue&type=template&id=e660626a&scoped=true"
import script from "./ProjectContentDisplay.vue?vue&type=script&lang=js"
export * from "./ProjectContentDisplay.vue?vue&type=script&lang=js"
import style0 from "./ProjectContentDisplay.vue?vue&type=style&index=0&id=e660626a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e660626a",
  null
  
)

export default component.exports